import { createApp } from 'vue/dist/vue.esm-bundler.js'
import Alert from "./backend/ui/Alert.vue";
import Button from "./backend/ui/Button.vue";
import {UseDark} from "@vueuse/components";
import Logo from "./backend/components/Logo.vue";

createApp()
    .component('UiAlert', Alert)
    .component('UiButton', Button)
    .component('UseDark', UseDark)
    .component('Logo', Logo)
    // .setup(() => {
    //
    // })
    .mount('#app')
